// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e2337816","400":"704ef195"}[chunkId] + ".chunk.js";
};